import Vue from 'vue';
import { Form, FormItem, Input, Button,Checkbox,Radio } from 'element-ui';

Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Radio);